var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((11),function(i){return _c('td',{key:i,staticClass:"payout_bet_odds",attrs:{"in":"","id":_vm.identifier + '_' + (i + 1)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }